import React from "react";
import { useSignIn } from "../../Pregrine/SignIn/useSignIn";
import classes from "./signIn.module.css";
import login from "../../assets/images/Login.webp";
import { Link } from "react-router-dom";
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";

const SignIn = (props) => {
  const { guestSignIn, toggleActiveContent } = props;
  const talonProps = useSignIn();
  const {
    handleSubmit,
    isValidEmail,
    isValidPassword,
    setEmail,
    setPassword,
    email,
    password,
    passwordError,
    emailError,
    apiError,
    showPassword,
    handlePassword,
  } = talonProps;

  return (
    <section className={`${classes.login} mb-4 `}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 left-section">
            <img src={login} className="img-fluid pt-5 pb-3" />
          </div>
          {/* <div className="col-lg-6 d-block d-md-none d-lg-none">
            <img src={logingif} className="img-fluid pt-2 pb-3" />
          </div> */}
          <div className="col-lg-6 right-section">
            <div className={classes["login-container"]}>
              {/* <h6>Welcome Back !</h6>
              <h2 className="mb-0">Login</h2>
              <small className={classes.message}>Buy Your Dream</small> */}
              <form className={classes["login-form"]} onSubmit={handleSubmit}>
                <h2 className={classes["login-title"]}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g fill="none" fill-rule="evenodd">
                      <path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" />
                      <path
                        fill="currentColor"
                        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2M8.5 9.5a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0m9.758 7.484A7.985 7.985 0 0 1 12 20a7.985 7.985 0 0 1-6.258-3.016C7.363 15.821 9.575 15 12 15s4.637.821 6.258 1.984"
                      />
                    </g>
                  </svg>{" "}
                  Login
                </h2>
                <div
                  className="col-lg-12 mb-2"
                  style={{ margin: "0px", padding: "0px" }}
                >
                  <div className={classes.outln}>
                    <input
                      className={`form-control ${classes.username}`}
                      type="text"
                      placeholder="Email"
                      onBlur={isValidEmail}
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    />
                  </div>
                  <div className="row">
                    <div
                      className={`text-left text-small col-md-12 ${classes.color_red}`}
                    >
                      {emailError}
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-12 mb-2"
                  style={{ margin: "0px", padding: "0px" }}
                >
                  <div className={classes.outln}>
                    <div className={classes.inputGroup}>
                      <input
                        className={`form-control ${classes.password}`}
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        onBlur={isValidPassword}
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                      />
                    </div>
                    <div className={` ${classes.eyeicon}`}>
                      <span>
                        {showPassword ? (
                          <FaEyeSlash onClick={handlePassword} />
                        ) : (
                          <FaEye onClick={handlePassword} />
                        )}
                      </span>
                    </div>
                  </div>

                  <div
                    className={`text-left text-small col-md-12 ${classes.color_red}`}
                  >
                    {passwordError}
                  </div>
                </div>
                {apiError && (
                  <div className="row">
                    <div
                      className={`text-left text-small col-md-12 ${classes.color_red}`}
                    >
                      {apiError}
                    </div>
                  </div>
                )}

                <div className="row mt-3">
                  <div className="col-lg-12 text-end ">
                    <input
                      className={classes.applybtn}
                      value="Sign In"
                      type="submit"
                    />
                  </div>
                </div>
                <div className={classes.links}>
                  <Link to="/forgot-password" className={classes.forgot}>
                    Forgot Password?
                  </Link>

                  <Link to="/create-account" className={classes.signup}>
                    Need an account? | <span>SIGNUP</span>
                  </Link>
                </div>
              </form>
            </div>
            <div className="row mt-3">
              <div className="col-lg-12 text-center">
                {guestSignIn && (
                  <button
                    className={classes.checkout}
                    onClick={toggleActiveContent}
                  >
                    <span style={{ color: "white" }}>Back to Checkout</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignIn;
